var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _path10, _path11, _g6, _path12, _path13, _g7, _path14, _g8, _path15, _g9, _path16, _path17, _g10, _path18, _path19, _g11, _path20, _path21, _g12, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaniervide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 134,
    viewBox: "0 0 89 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8311 24.378C18.8311 24.378 40.1488 22.9174 40.294 45.8376C17.3729 45.6922 18.8311 24.378 18.8311 24.378Z",
    fill: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 22,
    width: 26,
    height: 26
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5234 22.5234H42.0148V47.2743H17.5234V22.5234Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5456 47.0738L40.292 47.0672C32.8991 47.0176 27.1491 44.8399 23.2002 40.5837C17.018 33.9251 17.5755 24.6724 17.6019 24.2825L17.6745 23.2085L18.7533 23.1325C18.7533 23.1325 19.0568 23.1094 19.5912 23.1094C23.2332 23.1094 41.4005 24.2065 41.539 45.818L41.5456 47.0738Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 0,
    width: 18,
    height: 35
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.25 0H52.9851V34.3637H35.25V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2159 33.9321L43.3351 33.0399C38.1392 27.7791 35.6156 22.1713 35.8333 16.3718C36.1731 7.29102 43.1075 1.14461 43.4044 0.89016L44.2159 0.179688L45.0307 0.89016C45.3276 1.14461 52.262 7.29102 52.6018 16.3718C52.8195 22.1713 50.2958 27.7791 45.1 33.0399L44.2159 33.9321Z",
    fill: "#CCCCCC"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2207 24.378C70.2207 24.378 48.9063 22.9174 48.7578 45.8376C71.6822 45.6922 70.2207 24.378 70.2207 24.378Z",
    fill: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 22,
    width: 25,
    height: 26
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0781 22.5234H71.5695V47.2743H47.0781V22.5234Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5156 47.0738L47.5255 45.818C47.6641 24.2065 65.8314 23.1094 69.4701 23.1094C70.0078 23.1094 70.3113 23.1325 70.3113 23.1325L71.3868 23.2085L71.4626 24.2825C71.489 24.6724 72.0466 33.9218 65.8643 40.5837C61.9188 44.8399 56.1655 47.0176 48.7692 47.0672L47.5156 47.0738Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 36,
    width: 59,
    height: 67
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8203 36.5938H73.2483V102.797H15.8203V36.5938Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 36,
    width: 57,
    height: 67
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8376 102.788V36.6382C54.643 36.625 54.4516 36.625 54.257 36.625H34.8328V102.788H54.8376ZM29.8547 102.788H34.8328V36.6382H34.724C26.6746 36.6382 19.6082 43.2175 19.0276 51.2508L16.306 88.1921C15.7089 96.2088 21.8086 102.788 29.8547 102.788ZM59.123 102.788C67.1724 102.788 73.2688 96.2088 72.675 88.1755L69.9501 51.2376C69.3695 43.3993 62.6231 36.9455 54.8244 36.6382V102.788H59.123Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.7088 102.781H16.2969V36.5781H72.7088V102.781Z",
    fill: "#EDEDED"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 34,
    width: 26,
    height: 27
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 34.9141H40.712V60.6695H15V34.9141Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 34,
    width: 26,
    height: 27
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.856 34.9219C20.7567 34.9219 15 40.685 15 47.7996C15 54.9109 20.7567 60.6773 27.856 60.6773C34.9553 60.6773 40.712 54.9109 40.712 47.7996C40.712 40.685 34.9553 34.9219 27.856 34.9219Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 34.9219H40.712V60.6773H15V34.9219Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 39,
    width: 17,
    height: 17
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8438 39.75H35.8766V55.8133H19.8438V39.75Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 39,
    width: 17,
    height: 17
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8524 39.7422C23.4252 39.7422 19.8359 43.3375 19.8359 47.7755C19.8359 52.2101 23.4252 55.8055 27.8524 55.8055C32.2795 55.8055 35.8688 52.2101 35.8688 47.7755C35.8688 43.3375 32.2795 39.7422 27.8524 39.7422Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8359 39.7422H35.8688V55.8055H19.8359V39.7422Z",
    fill: "#0E0B26"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 42,
    width: 8,
    height: 7
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9609 42.5078H33.1333V48.6906H26.9609V42.5078Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 42,
    width: 8,
    height: 7
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0644 42.5156C28.3588 42.5156 26.9766 43.9002 26.9766 45.6054C26.9766 47.3138 28.3588 48.6984 30.0644 48.6984C31.7666 48.6984 33.1489 47.3138 33.1489 45.6054C33.1489 43.9002 31.7666 42.5156 30.0644 42.5156Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9766 42.5156H33.1489V48.6984H26.9766V42.5156Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 68,
    width: 19,
    height: 22
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5078 68.6172H53.6982V89.2969H35.5078V68.6172Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6009 94.713C44.0038 94.713 43.4133 94.6304 42.8294 94.4619C42.2422 94.2966 41.6747 94.0488 41.1238 93.7216C40.5729 93.3912 40.0484 92.9913 39.5535 92.5155C39.0554 92.0396 38.5968 91.4977 38.1746 90.893C37.7523 90.2849 37.3762 89.6273 37.0463 88.9136C36.7131 88.2031 36.4327 87.4497 36.2051 86.6566C35.9775 85.8668 35.8059 85.0506 35.6872 84.2112C35.5717 83.3686 35.5156 82.5226 35.5156 81.6634C35.5156 80.8076 35.5717 79.9583 35.6872 79.119C35.8059 78.2796 35.9775 77.4634 36.2051 76.6703C36.4327 75.8805 36.7131 75.1271 37.0463 74.4166C37.3762 73.7028 37.7523 73.0452 38.1746 72.4372C38.5968 71.8325 39.0554 71.2905 39.5535 70.8147C40.0484 70.3388 40.5729 69.939 41.1238 69.6085C41.6747 69.2814 42.2422 69.0336 42.8294 68.8683C43.4133 68.6998 44.0038 68.6172 44.6009 68.6172C45.198 68.6172 45.7885 68.6998 46.3724 68.8683C46.9597 69.0336 47.5271 69.2814 48.078 69.6085C48.6289 69.939 49.1535 70.3388 49.6483 70.8147C50.1464 71.2905 50.605 71.8325 51.0273 72.4372C51.4495 73.0452 51.8256 73.7028 52.1555 74.4166C52.4887 75.1271 52.7691 75.8805 52.9967 76.6703C53.2243 77.4634 53.3959 78.2796 53.5147 79.119C53.6301 79.9583 53.6862 80.8076 53.6862 81.6634C53.6862 82.5226 53.6301 83.3686 53.5147 84.2112C53.3959 85.0506 53.2243 85.8668 52.9967 86.6566C52.7691 87.4497 52.4887 88.2031 52.1555 88.9136C51.8256 89.6273 51.4495 90.2849 51.0273 90.893C50.605 91.4977 50.1464 92.0396 49.6483 92.5155C49.1535 92.9913 48.6289 93.3912 48.078 93.7216C47.5271 94.0488 46.9597 94.2966 46.3724 94.4619C45.7885 94.6304 45.198 94.713 44.6009 94.713Z",
    fill: "#0E0B26"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 82,
    width: 17,
    height: 12
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5469 82.3906H52.2762V93.7152H36.5469V82.3906Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2762 88.0591C52.2762 88.4292 52.2234 88.796 52.1245 89.1628C52.0222 89.5263 51.8738 89.8799 51.6758 90.2235C51.4779 90.5672 51.2371 90.8911 50.9501 91.2017C50.663 91.509 50.3365 91.7965 49.9703 92.0576C49.6074 92.3219 49.2082 92.5565 48.7794 92.7614C48.3505 92.9696 47.8985 93.1414 47.4202 93.2835C46.9418 93.4256 46.4503 93.5347 45.9456 93.6074C45.4375 93.6801 44.9262 93.7164 44.4116 93.7164C43.8936 93.7164 43.3823 93.6801 42.8775 93.6074C42.3695 93.5347 41.878 93.4256 41.3996 93.2835C40.9246 93.1414 40.4693 92.9696 40.0405 92.7614C39.6116 92.5565 39.2124 92.3219 38.8495 92.0576C38.4834 91.7965 38.1568 91.509 37.8698 91.2017C37.5827 90.8911 37.3419 90.5672 37.144 90.2235C36.946 89.8799 36.7976 89.5263 36.6953 89.1628C36.5964 88.796 36.5469 88.4292 36.5469 88.0591C36.5469 87.6857 36.5964 87.3189 36.6953 86.9521C36.7976 86.5886 36.946 86.235 37.144 85.8913C37.3419 85.5476 37.5827 85.2238 37.8698 84.9132C38.1568 84.6059 38.4834 84.3184 38.8495 84.0573C39.2124 83.7929 39.6116 83.5583 40.0405 83.3534C40.4693 83.1453 40.9246 82.9734 41.3996 82.8313C41.878 82.6892 42.3695 82.5802 42.8775 82.5075C43.3823 82.4348 43.8936 82.3984 44.4116 82.3984C44.9262 82.3984 45.4375 82.4348 45.9456 82.5075C46.4503 82.5802 46.9418 82.6892 47.4202 82.8313C47.8985 82.9734 48.3505 83.1453 48.7794 83.3534C49.2082 83.5583 49.6074 83.7929 49.9703 84.0573C50.3365 84.3184 50.663 84.6059 50.9501 84.9132C51.2371 85.2238 51.4779 85.5476 51.6758 85.8913C51.8738 86.235 52.0222 86.5886 52.1245 86.9521C52.2234 87.3189 52.2762 87.6857 52.2762 88.0591Z",
    fill: "#BDBDBD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 34,
    width: 26,
    height: 27
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2891 34.9141H74.001V60.6695H48.2891V34.9141Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 34,
    width: 27,
    height: 27
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1529 34.9219C54.0502 34.9219 48.2969 40.685 48.2969 47.7996C48.2969 54.9109 54.0502 60.6773 61.1529 60.6773C68.2522 60.6773 74.0088 54.9109 74.0088 47.7996C74.0088 40.685 68.2522 34.9219 61.1529 34.9219Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2969 34.9219H74.0088V60.6773H48.2969V34.9219Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 39,
    width: 17,
    height: 17
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1328 39.75H69.169V55.8133H53.1328V39.75Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 39,
    width: 17,
    height: 17
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1604 39.7422C56.7299 39.7422 53.1406 43.3375 53.1406 47.7755C53.1406 52.2101 56.7299 55.8055 61.1604 55.8055C65.5875 55.8055 69.1768 52.2101 69.1768 47.7755C69.1768 43.3375 65.5875 39.7422 61.1604 39.7422Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1406 39.7422H69.1768V55.8055H53.1406V39.7422Z",
    fill: "#0E0B26"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 42,
    width: 7,
    height: 7
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5156 42.5078H66.6879V48.6906H60.5156V42.5078Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 42,
    width: 7,
    height: 7
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6079 42.5156C61.9024 42.5156 60.5234 43.9002 60.5234 45.6054C60.5234 47.3138 61.9024 48.6984 63.6079 48.6984C65.3135 48.6984 66.6958 47.3138 66.6958 45.6054C66.6958 43.9002 65.3135 42.5156 63.6079 42.5156Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5234 42.5156H66.6958V48.6984H60.5234V42.5156Z",
    fill: "white"
  })))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29688 121.578C5.77083 121.578 6.84635 121.896 7.52344 122.531C8.20052 123.161 8.53906 124.031 8.53906 125.141C8.53906 125.641 8.46354 126.12 8.3125 126.578C8.16146 127.031 7.91406 127.435 7.57031 127.789C7.23177 128.143 6.77865 128.424 6.21094 128.633C5.64323 128.836 4.94271 128.938 4.10938 128.938H3.07031V133H0.648438V121.578H4.29688ZM4.17188 123.562H3.07031V126.953H3.86719C4.32031 126.953 4.71354 126.893 5.04688 126.773C5.38021 126.654 5.63802 126.466 5.82031 126.211C6.0026 125.956 6.09375 125.628 6.09375 125.227C6.09375 124.664 5.9375 124.247 5.625 123.977C5.3125 123.701 4.82812 123.562 4.17188 123.562ZM14.0859 124.086C15.2578 124.086 16.1562 124.341 16.7812 124.852C17.4062 125.362 17.7188 126.138 17.7188 127.18V133H16.0547L15.5938 131.812H15.5312C15.2812 132.125 15.026 132.38 14.7656 132.578C14.5052 132.776 14.2057 132.922 13.8672 133.016C13.5286 133.109 13.1172 133.156 12.6328 133.156C12.1172 133.156 11.6536 133.057 11.2422 132.859C10.8359 132.661 10.5156 132.359 10.2812 131.953C10.0469 131.542 9.92969 131.021 9.92969 130.391C9.92969 129.464 10.2552 128.781 10.9062 128.344C11.5573 127.901 12.5339 127.656 13.8359 127.609L15.3516 127.562V127.18C15.3516 126.721 15.2318 126.385 14.9922 126.172C14.7526 125.958 14.4193 125.852 13.9922 125.852C13.5703 125.852 13.1562 125.911 12.75 126.031C12.3438 126.151 11.9375 126.302 11.5312 126.484L10.7422 124.875C11.2057 124.63 11.724 124.438 12.2969 124.297C12.875 124.156 13.4714 124.086 14.0859 124.086ZM15.3516 128.953L14.4297 128.984C13.6589 129.005 13.1224 129.143 12.8203 129.398C12.5234 129.654 12.375 129.99 12.375 130.406C12.375 130.771 12.4818 131.031 12.6953 131.188C12.9089 131.339 13.1875 131.414 13.5312 131.414C14.0417 131.414 14.4714 131.263 14.8203 130.961C15.1745 130.659 15.3516 130.229 15.3516 129.672V128.953ZM25.1406 124.102C26.0729 124.102 26.8229 124.357 27.3906 124.867C27.9583 125.372 28.2422 126.185 28.2422 127.305V133H25.8594V127.898C25.8594 127.273 25.7448 126.802 25.5156 126.484C25.2917 126.167 24.9375 126.008 24.4531 126.008C23.724 126.008 23.2266 126.255 22.9609 126.75C22.6953 127.245 22.5625 127.958 22.5625 128.891V133H20.1797V124.266H22L22.3203 125.383H22.4531C22.6406 125.081 22.8724 124.836 23.1484 124.648C23.4297 124.461 23.7396 124.323 24.0781 124.234C24.4219 124.146 24.776 124.102 25.1406 124.102ZM33.0781 124.266V133H30.6953V124.266H33.0781ZM31.8906 120.844C32.2448 120.844 32.5495 120.927 32.8047 121.094C33.0599 121.255 33.1875 121.56 33.1875 122.008C33.1875 122.451 33.0599 122.758 32.8047 122.93C32.5495 123.096 32.2448 123.18 31.8906 123.18C31.5312 123.18 31.224 123.096 30.9688 122.93C30.7188 122.758 30.5938 122.451 30.5938 122.008C30.5938 121.56 30.7188 121.255 30.9688 121.094C31.224 120.927 31.5312 120.844 31.8906 120.844ZM39.1875 124.102C39.9948 124.102 40.6901 124.258 41.2734 124.57C41.8568 124.878 42.3073 125.326 42.625 125.914C42.9427 126.503 43.1016 127.221 43.1016 128.07V129.227H37.4688C37.4948 129.898 37.6953 130.427 38.0703 130.812C38.4505 131.193 38.9766 131.383 39.6484 131.383C40.2057 131.383 40.7161 131.326 41.1797 131.211C41.6432 131.096 42.1198 130.924 42.6094 130.695V132.539C42.1771 132.753 41.724 132.909 41.25 133.008C40.7812 133.107 40.2109 133.156 39.5391 133.156C38.6641 133.156 37.888 132.995 37.2109 132.672C36.5391 132.349 36.0104 131.857 35.625 131.195C35.2448 130.534 35.0547 129.701 35.0547 128.695C35.0547 127.674 35.2266 126.826 35.5703 126.148C35.9193 125.466 36.4036 124.956 37.0234 124.617C37.6432 124.273 38.3646 124.102 39.1875 124.102ZM39.2031 125.797C38.7396 125.797 38.3542 125.945 38.0469 126.242C37.7448 126.539 37.5703 127.005 37.5234 127.641H40.8672C40.862 127.286 40.7969 126.971 40.6719 126.695C40.5521 126.419 40.3698 126.201 40.125 126.039C39.8854 125.878 39.5781 125.797 39.2031 125.797ZM49.9141 124.102C50.0339 124.102 50.1719 124.109 50.3281 124.125C50.4896 124.135 50.6198 124.151 50.7188 124.172L50.5391 126.406C50.4609 126.38 50.349 126.362 50.2031 126.352C50.0625 126.336 49.9401 126.328 49.8359 126.328C49.5286 126.328 49.2292 126.367 48.9375 126.445C48.651 126.523 48.3932 126.651 48.1641 126.828C47.9349 127 47.7526 127.229 47.6172 127.516C47.487 127.797 47.4219 128.143 47.4219 128.555V133H45.0391V124.266H46.8438L47.1953 125.734H47.3125C47.4844 125.438 47.6979 125.167 47.9531 124.922C48.2135 124.672 48.5078 124.474 48.8359 124.328C49.1693 124.177 49.5286 124.102 49.9141 124.102ZM58.5391 133L55.2109 124.266H57.7031L59.3906 129.242C59.4844 129.534 59.5573 129.841 59.6094 130.164C59.6667 130.487 59.7057 130.776 59.7266 131.031H59.7891C59.8047 130.755 59.8411 130.461 59.8984 130.148C59.9609 129.836 60.0417 129.534 60.1406 129.242L61.8203 124.266H64.3125L60.9844 133H58.5391ZM67.9531 124.266V133H65.5703V124.266H67.9531ZM66.7656 120.844C67.1198 120.844 67.4245 120.927 67.6797 121.094C67.9349 121.255 68.0625 121.56 68.0625 122.008C68.0625 122.451 67.9349 122.758 67.6797 122.93C67.4245 123.096 67.1198 123.18 66.7656 123.18C66.4062 123.18 66.099 123.096 65.8438 122.93C65.5938 122.758 65.4688 122.451 65.4688 122.008C65.4688 121.56 65.5938 121.255 65.8438 121.094C66.099 120.927 66.4062 120.844 66.7656 120.844ZM73.2266 133.156C72.2526 133.156 71.4583 132.776 70.8438 132.016C70.2344 131.25 69.9297 130.128 69.9297 128.648C69.9297 127.154 70.2396 126.023 70.8594 125.258C71.4792 124.487 72.2891 124.102 73.2891 124.102C73.7057 124.102 74.0729 124.159 74.3906 124.273C74.7083 124.388 74.9818 124.542 75.2109 124.734C75.4453 124.927 75.6432 125.143 75.8047 125.383H75.8828C75.8516 125.216 75.8125 124.971 75.7656 124.648C75.724 124.32 75.7031 123.984 75.7031 123.641V120.844H78.0938V133H76.2656L75.8047 131.867H75.7031C75.5521 132.107 75.362 132.326 75.1328 132.523C74.9089 132.716 74.6406 132.87 74.3281 132.984C74.0156 133.099 73.6484 133.156 73.2266 133.156ZM74.0625 131.258C74.7135 131.258 75.1719 131.065 75.4375 130.68C75.7083 130.289 75.8516 129.703 75.8672 128.922V128.664C75.8672 127.815 75.737 127.167 75.4766 126.719C75.2161 126.266 74.7318 126.039 74.0234 126.039C73.4974 126.039 73.0859 126.266 72.7891 126.719C72.4922 127.172 72.3438 127.826 72.3438 128.68C72.3438 129.534 72.4922 130.177 72.7891 130.609C73.0911 131.042 73.5156 131.258 74.0625 131.258ZM84.1875 124.102C84.9948 124.102 85.6901 124.258 86.2734 124.57C86.8568 124.878 87.3073 125.326 87.625 125.914C87.9427 126.503 88.1016 127.221 88.1016 128.07V129.227H82.4688C82.4948 129.898 82.6953 130.427 83.0703 130.812C83.4505 131.193 83.9766 131.383 84.6484 131.383C85.2057 131.383 85.7161 131.326 86.1797 131.211C86.6432 131.096 87.1198 130.924 87.6094 130.695V132.539C87.1771 132.753 86.724 132.909 86.25 133.008C85.7812 133.107 85.2109 133.156 84.5391 133.156C83.6641 133.156 82.888 132.995 82.2109 132.672C81.5391 132.349 81.0104 131.857 80.625 131.195C80.2448 130.534 80.0547 129.701 80.0547 128.695C80.0547 127.674 80.2266 126.826 80.5703 126.148C80.9193 125.466 81.4036 124.956 82.0234 124.617C82.6432 124.273 83.3646 124.102 84.1875 124.102ZM84.2031 125.797C83.7396 125.797 83.3542 125.945 83.0469 126.242C82.7448 126.539 82.5703 127.005 82.5234 127.641H85.8672C85.862 127.286 85.7969 126.971 85.6719 126.695C85.5521 126.419 85.3698 126.201 85.125 126.039C84.8854 125.878 84.5781 125.797 84.2031 125.797Z",
    fill: "#CBCBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaniervide);
export default __webpack_public_path__ + "static/media/paniervide.447ba8513d73aeffa12e10e7cd2c5423.svg";
export { ForwardRef as ReactComponent };